export default class UpdateTagModel {
    organizationId = null;
    id = null;
    name = null;
    isActive = false;
    color = null;
    group = null;
    description = null;
    icon = null;

    constructor(id, organizationId, name, isActive, color = null, group = null, description = null, icon = null) {
        this.id = id;
        this.organizationId = organizationId;
        this.name = name;
        this.isActive = isActive;
        this.color = color;
        this.group = group;
        this.description = description;
        this.icon = icon;
    }
}
